module.exports = __webpack_public_path__ + "static/media/skeletonSpoon.3853e69b.gif";